export interface IStepInfo {
    title: string;
}

type Steps = {
    amountRequested: IStepInfo;
    reasonForLoan: IStepInfo;
    aboutCompany: IStepInfo;
    responsibleInfo: IStepInfo;
    privacyTerms: IStepInfo;
};

export const defaultSteps: Steps = {
    amountRequested: {
        title: 'qual valor de empréstimo ajudaria a sua empresa neste momento?',
    },
    reasonForLoan: {
        title: 'e como pretende usar <br />o empréstimo?',
    },
    aboutCompany: {
        title: 'agora, sobre <br className="d-block d-sm-none" />a sua empresa',
    },
    responsibleInfo: {
        title: 'conte sobre você',
    },
    privacyTerms: {
        title: 'tudo certo até <br className="d-block d-sm-none" />aqui, %s?',
    },
};

export const partnersSteps: Steps = {
    amountRequested: {
        title: 'qual valor de empréstimo ajudaria a empresa do seu cliente?',
    },
    reasonForLoan: {
        title: 'e como pretende usar <br />o empréstimo?',
    },
    aboutCompany: {
        title: 'conte sobre <br className="d-block d-sm-none" />a empresa',
    },
    responsibleInfo: {
        title: 'agora, sobre o seu cliente',
    },
    privacyTerms: {
        title: 'tudo certo até aqui?',
    },
};
